import { LOGO_SQUARE_URL } from "@/constants";
import { useFetchData } from "@/hooks";
import { Skeleton } from "@heroui/react";

const PrintHeader = ({ title }) => {
    const { data: settings, isLoading } = useFetchData("app-settings/company");

    if (isLoading) {
        return (
            <div className="mb-3 border-b-2 border-black pb-3">
                <div className="flex items-end justify-between">
                    <div className="flex flex-col gap-1.5">
                        <div className="flex items-center gap-3">
                            <Skeleton className="h-10 w-10 rounded" />
                            <Skeleton className="h-6 w-48 rounded" />
                        </div>
                        <Skeleton className="h-3 w-36 rounded" />
                        <Skeleton className="h-3 w-56 rounded" />
                    </div>
                    <Skeleton className="h-6 w-40 rounded" />
                </div>
            </div>
        );
    }

    const c = settings || { name: "", address: "", phone: "", email: "" };

    return (
        <div className="mb-3 border-b-2 border-black pb-3">
            <div className="flex items-end justify-between">
                <div>
                    <div className="flex items-center gap-3">
                        <img
                            src={c.logo || LOGO_SQUARE_URL}
                            alt={c.name}
                            className="h-10 w-10 object-contain"
                        />
                        <h1 className="text-xl font-bold">{c.name}</h1>
                    </div>
                    <p className="text-default-600 text-xs">{c.address}</p>
                    <p className="text-default-600 text-xs">
                        Telp: {c.phone} | Email: {c.email}
                    </p>
                </div>
                <div className="text-right text-lg font-bold">{title}</div>
            </div>
        </div>
    );
};

export default PrintHeader;
